import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
  private apiUrl = GlobalConstantsComponent.apiURL + 'care/';

  constructor(
    private http: HttpClient,
  ) { }


  getProperties() {
    return this.http.get(`${this.apiUrl}properties`) as any;
  }

  getBookings() {
    return this.http.get<{ property_id: number[], user_id: number[], house_id: any[] }>(`${this.apiUrl}getBookings`);
  }
  getAllBookings(page, perPage, queryParams?, magic?) {
    return this.http.get(`${this.apiUrl}getAllBookings?page=`+ page +`&perPage=`+ perPage +`&` + queryParams + `magic=` + magic) as any;
  }

  updateProperty(data) {
    return this.http.post(this.apiUrl + 'property/update', data)
  }

  generateSummary(id) {
    return this.http.get(`${this.apiUrl}property/summary/`+ id) as any;
  }

  getLeads(grouped?) {
    if(!grouped){
      grouped = 'raw';
    }
    return this.http.get(this.apiUrl + 'kpi/getHousingLead/' + grouped) as any;
  }

  getLeadsEs(){
      return this.http.get(this.apiUrl + 'getHousingLeadsEs') as any;
  }

  getNotifications() {
    return this.http.get(this.apiUrl + 'notifications') as any;
  }

  updateNotifications(data) {
    return this.http.post(this.apiUrl + 'notifications/update', data);
  }

  getContacts(){
    return this.http.get(this.apiUrl + 'getContacts') as any;
  }


  forceStartDate(datas) {
    return this.http.post(this.apiUrl + 'forceStartDate', datas) ;
  }

  closeBooking(bookingId){
    return this.http.post(`${this.apiUrl}closeBooking/`+ bookingId, bookingId);
  }

  getAmenities() {
    return this.http.get(`${this.apiUrl}getAllAmenities`) as any;
  }


  // @TODO : Typer les variables comme il faut et tester que tout fonctionne après (Gwen 20/06/2024)
  getBookingFilters() {
    return this.http.get<{ agents: any[], metropoles: any[], partners: any[] }>(`${this.apiUrl}getBookingFilters`);
  }

  addNoteToBooking(data) {
    return this.http.post(this.apiUrl + 'addNoteToBooking', data);
  }

  updateBooking(bookingId, data) {
    return this.http.post(this.apiUrl + 'updateBooking/' + bookingId, data);
  }

  getPaymentLink(bookingId) {
    return this.http.get(`${this.apiUrl}getPaymentLink/` + bookingId);
  }


  updatePartnerProperties(partnerId: number) {
    return this.http.post(this.apiUrl + 'updatePartnerProperties', {partnerId: partnerId});
  }
}
